


let app_server_url = process.env.REACT_APP_SERVER_URL;
//Interpreter URLS
export const url_login = app_server_url + "/api_int_login";
export const url_email_forgot = app_server_url + "/api_int_email_forgot";
export const url_otp_verify = app_server_url + "/api_int_otp_verify";
export const url_fetch_dashboard = app_server_url + "/api_int_fetch_dashboard";
export const url_fetch_assignment_lists = app_server_url + "/api_int_fetch_assignment_lists";
export const url_get_bell_notification_messages = app_server_url + "/api_int_get_bell_notification_messages";
export const url_assignment_accept_reject = app_server_url + "/api_int_assignment_accept_reject";
export const url_fetch_assignment_confirmation_detail = app_server_url + "/api_int_fetch_assignment_confirmation_detail";
export const url_support_form = app_server_url + "/api_int_support_form";
export const url_store_datas = app_server_url + "/api_int_store_datas";
export const url_change_assignment_status = app_server_url + "/api_int_change_assignment_status";
export const url_get_voucher_html = app_server_url + "/api_int_get_voucher_html";
export const url_get_default_invoice_blob = app_server_url + "/api_int_get_default_invoice_blob";
export const url_get_assign_bill_details = app_server_url + "/api_int_get_assign_bill_details";
export const url_insert_invoice = app_server_url + "/api_int_insert_invoice";
export const url_get_asssignment_summary = app_server_url + "/api_int_get_asssignment_summary";
export const url_cancel_assignment = app_server_url + "/api_int_cancel_assignment";
export const url_get_invoice_details = app_server_url + "/api_int_get_invoice_details";
export const url_list_get_by_status = app_server_url + "/api_int_list_get_by_status";
export const url_update_countrycode_timezone = app_server_url + "/api_int_update_countrycode_timezone";
export const url_fetch_vacation_lists = app_server_url + "/api_int_fetch_vacation_lists";
export const url_vacation_setting = app_server_url + "/api_int_vacation_setting";
export const url_delete_vacation_setting = app_server_url + "/api_int_delete_vacation_setting";
export const url_api_int_profile_details = app_server_url + "/api_int_profile_details";
export const url_reject_interp_signature = app_server_url + "/api_int_reject_interp_signature";
export const url_view_bill_pdf_generation = app_server_url + "/api_int_view_bill_pdf_generation";